const ACTIVE_CLASS = 'product-compatible-modal__category-grid-item--active';
const CONTROLS_CLASS = 'product-compatible-modal__select-category-controls';
const CONTROLS_CLASS_ACTIVE = `${CONTROLS_CLASS}--active`;
export class CategorySelection {
  constructor() {
    this.modal = null;
    this.categories = [];
    this.grid = null;
    this.section = null;
    this.showResultsBtn = null;
    this.productResults = null;
    this.clearResults = null;
  }

  init(modal, callback, categories, clearResults, resetAll) {
    this.modal = modal;
    this.apiCategories = categories || [];
    this.resetAll = resetAll;
    this.section = this.modal.getElementsByClassName(
      'product-compatible-modal__select-category-section',
    )?.[0];

    this.grid = this.modal.getElementsByClassName('product-compatible-modal__category-grid')?.[0];
    this.callback = callback;

    if (this.section) {
      this.section.style.display = 'block';
    }

    if (this.grid) {
      this.getCategoriesAndInsertToDOM();
    }

    this.categories = [
      ...this.modal.querySelectorAll('.product-compatible-modal__category-grid-item'),
    ];
    this.resetBtn = this.modal.getElementsByClassName(
      'product-compatible-modal__select-category-controls--reset',
    )?.[0];
    this.showResultsBtn = this.modal.getElementsByClassName(
      'product-compatible-modal__select-category-controls--show-results',
    )?.[0];
    this.controls = this.modal.getElementsByClassName(CONTROLS_CLASS)?.[0];

    this.clearResults = clearResults;

    if (!this.modal) return;

    this.categories.forEach((category) => {
      category.addEventListener('click', () => {
        const isActive = category.classList.contains(ACTIVE_CLASS);

        if (isActive) {
          category.classList.remove(ACTIVE_CLASS);
        } else {
          category.classList.add(ACTIVE_CLASS);
        }

        this.toggleControls();
      });
    });

    if (this.resetBtn) {
      this.resetBtn.addEventListener('click', () => {
        if (this.resetAll) {
          this.resetAll();
          return;
        }

        this.categories.forEach((el) => el.classList.remove(ACTIVE_CLASS));

        this.toggleControls();
      });
    }

    if (this.showResultsBtn) {
      this.showResultsBtn.addEventListener('click', () => {
        this.callback();
      });
    }

    this.toggleControls();
  }

  getSelectedCategoriesCount() {
    return (
      this.categories.filter((category) => category.classList.contains(ACTIVE_CLASS))?.length || 0
    );
  }

  getSelectedCategories() {
    return this.categories
      .filter((category) => category.classList.contains(ACTIVE_CLASS))
      .map((category) => category.getAttribute('data-category') || category.textContent.trim())
      .filter(Boolean);
  }

  hide() {
    this.categories.forEach((el) => el.classList.remove(ACTIVE_CLASS));
    this.toggleControls();

    if (this.section) {
      this.section.style.display = 'none';
    }
  }

  toggleControls() {
    if (this.controls) {
      const selectedCategoriesCount = this.getSelectedCategoriesCount();
      const hasCategories = this.categories.length > 0 && !!selectedCategoriesCount;

      if (!hasCategories && this.controls.classList.contains(CONTROLS_CLASS_ACTIVE))
        this.controls.classList.remove(CONTROLS_CLASS_ACTIVE);
      if (hasCategories && !this.controls.classList.contains(CONTROLS_CLASS_ACTIVE))
        this.controls.classList.add(CONTROLS_CLASS_ACTIVE);

      if (!selectedCategoriesCount) {
        this.clearResults();
      }
    }
  }

  getCategoriesAndInsertToDOM() {
    // Categories come from the spare-parts-categories endpoint (ProductTypeCodes for the
    // selected model). id = value sent back to the API; displayValue = label shown in the tile.
    const categoriesFromApi = this.apiCategories || [];

    this.grid.innerHTML = '';
    categoriesFromApi.forEach(({ id, displayValue }) => {
      const item = document.createElement('button');
      item.className = 'product-compatible-modal__category-grid-item';
      item.type = 'button';
      // setAttribute stores the id verbatim so entities like &amp; survive round-trips.
      item.setAttribute('data-category', id);

      const label = document.createElement('span');
      label.textContent = displayValue;
      item.appendChild(label);

      this.grid.appendChild(item);
    });
  }
}
